import { TaskCategory } from '../../types/enums';
import type { DailyTasksResponse } from '../../types/task';

/**
 * Whether a relance is still in the agent's working list.
 *
 * Membership is decided by the task row, not the relance row: paying an invoice deletes the task while the
 * relance survives, so `GET /relances/{id}` still answers 200 for a relance that has left the list. The
 * daily list is the only place that reflects it.
 *
 * Only `CUSTOMER_RELANCE` sections carry items today — the guard mirrors `tasksStore`, whose
 * `GenericTaskSectionDto.items` is typed `never[]`.
 */
export const isRelanceListed = (dailyTasks: DailyTasksResponse, relanceId: string): boolean =>
    dailyTasks.sections.some(section =>
        section.type === TaskCategory.CUSTOMER_RELANCE
        && section.items.some(item => item.id === relanceId));
